import { bandColors } from '@tendedloop/shared/brand-colors';

/**
 * The building's own logo on a slim band at the top of the QR page, so the
 * visitor knows at a glance whose place this is. The logo sits on the band it
 * is drawn for (black for most brands). 48px tall: it never pushes the main
 * action below the fold.
 */
export function BrandBar({
  brand,
  fallbackName,
}: {
  brand: { name: string | null; logoUrl: string; logoBackground: 'dark' | 'light' };
  fallbackName: string;
}) {
  const band = bandColors(brand.logoBackground);
  return (
    <div
      className="flex h-12 shrink-0 items-center justify-center px-5"
      style={{ backgroundColor: band.bg, borderBottom: band.light ? '1px solid #e5e7eb' : undefined }}
      data-testid="brand-bar"
      data-brand-level="identity"
    >
      <img
        src={brand.logoUrl}
        alt={brand.name ?? fallbackName}
        className="h-7 w-auto max-w-[180px] object-contain"
        decoding="async"
      />
    </div>
  );
}
